import clsx from 'clsx';
import React from 'react';

const ActivityItemRow = (props) => {
  const { activityLog, time, component, userLabel } = props;

  return (
    <div className={clsx('row--activityItem', 'tw-flex tw-items-center', 'tw-mb-[10px]')}>
      <div
        className={clsx(
          'date',
          'tw-mr-[15px]',
          'tw-text-cfo-black',
          'tw-min-w-[70px] tw-max-w-[150px] tw-w-auto'
        )}
      >
        {time}
      </div>
      <div>
        <strong className={clsx('tw-text-cfo-black tw-font-brandonTextBold !tw-font-normal')}>
          {userLabel}
        </strong>
        {component(activityLog)}
      </div>
    </div>
  );
};

export default ActivityItemRow;
